const tableOfContentsPattern = new RegExp(
    '^\\[TOC(?:\\s+levels=([1-5,]+))?]\\s*$', 'i');

const tableOfContents = (state, startLine, endLine, silent) => {
  let token;
  const pos = state.bMarks[startLine] + state.tShift[startLine];
  const max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  if (state.src.charCodeAt(pos) !== 0x5B /* [ */) { return false; }

  // use whitespace as a line tokenizer and extract the first token
  // to test against the placeholder anchored pattern, rejecting if false
  const lineFirstToken = state.src.slice(pos, max);
  if (!tableOfContentsPattern.test(lineFirstToken)) return false;

  if (silent) return true;

  const matches = tableOfContentsPattern.exec(lineFirstToken);

  state.line = startLine + 1;

  token = state.push('table_of_contents_open', '', 1);
  token.markup = '';
  token.map = [startLine, state.line];
  token.attrs = [['levels', matches[1].split(',').map(level => parseInt(level))]];

  token = state.push('table_of_contents_close', '', 0);
  token.markup = '';
  token.map = [startLine, state.line];

  return true;
};

export const markdownTableOfContents = md => {
  md.block.ruler.before('table', 'toc', tableOfContents, {
    alt: ['paragraph', 'reference', 'blockquote'],
  });
};
